import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Button, Tab, Tabs, TextField, Box, Typography, Grid, IconButton, DialogActions } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import moment from "moment";
import TableComponent from "components/grid";
import CustomPagination from "components/CustomPagination";
import { RxCross2 } from "react-icons/rx";
import { useLazyGetEHSFindingListQuery } from "store/slices/apis/ehsFindingApiSlice";
import StatusBadge from "components/badge/StatusBadge";



const EhsFindingList = (props) => {
    const { header, open, handleClose, filter } = props;
    console.log("filter", filter)
    const { projectId } = useParams();
    const [loading, setLoading] = useState(false);
    const [sortOrder, setSortOrder] = React.useState('desc');
    const [sortBy, setSortBy] = React.useState('createdDate');
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);
    const dispatch = useDispatch();
    const [subTabValue, setSubTabValue] = useState(0)


    const [filters, setFilters] = useState({
        ...filter,
        ProjectId: projectId,
        SortBy: sortBy,
        SortOrder: sortOrder,
        PageNumber: pageNumber,
        PageSize: pageSize,


    });

    const [trigger, { data: ehsFindingData, isLoading: isloading, isFetching }] = useLazyGetEHSFindingListQuery()

    useEffect(() => {
        trigger(filters);
    }, []);




    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';

        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'
        };
        setFilters(updatedFilters);
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        trigger(updatedFilters);
    };

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };



    const col = [
        {
            name: "ID",
            field: "customId",
            width: "100px",
            sticky: true,
        },
        {
            name: "Date",
            field: "dateTime",
            width: "120px",
            sticky: true,
            renderer: (row) => (
                row?.dateTime ? moment.utc(row.dateTime).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "EHS Finding",
            field: "ehsFinding",
            width: "300px",
            sticky: true,
        },
        {
            name: "Finding Photographs",
            field: "findingPhotographs",
            renderer: (row) => {
                const images = row?.findingPhotographs || [];
                return (
                    <Box display="flex" gap={0.5} flexWrap="wrap">
                        {images.length > 0 ? (
                            images.slice(0, 1).map((file, index) => (
                                <Box key={index}>
                                    <img
                                        src={file?.filePath}
                                        alt="img"
                                        width={80}
                                        height={80}
                                        style={{
                                            objectFit: "cover",
                                            borderRadius: 4,
                                            border: "1px solid #ddd"
                                        }}

                                    />
                                </Box>
                            ))
                        ) : (
                            <Typography variant="caption">N/A</Typography>
                        )}
                    </Box>
                );
            }
        },
        {
            name: "Reported By",
            field: "reportedBy",
        },
        {
            name: "Recommendation",
            field: "recommendation",
            width: "300px",
        },
        {
            name: "Area",
            field: "area",
            width: "150px",
        },
        {
            name: "Location",
            field: "location",
            width: "150px",
          
        },
        {
            name: "Contractor & Sub Contractor Involved",
            field: "contractorSubContractorInvolved",
           
        },
        {
            name: "Category",
            field: "category",
            
        },
        {
            name: "PTW Issued",
            field: "ptwIssued",
            renderer: (row) => (
                <>{row?.ptwIssued === true ? "Yes" : "No"}</>
            )
        },
        {
            name: "PTW Issued By",
            field: "ptwIssuedBy",
        },
        {
            name: "Stop Work Recommended",
            field: "stopWorkRecommended",
            renderer: (row) => (
                <>{row?.stopWorkRecommended === true ? "Yes" : "No"}</>
            )
        },
        {
            name: "Target Closure Date",
            field: "targetClosureDate",
            renderer: (row) => (
                row?.targetClosureDate ? moment.utc(row.targetClosureDate).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "Action Owner",
            field: "actionOwner",
           
        },
        {
            name: "Compliance Statement",
            field: "complianceStatement",
            width: "300px",
        },
        {
            name: "Compliance Photographs",
            field: "compliancePhotographs",
            renderer: (row) => {
                const images = row?.compliancePhotographs || [];
                return (
                    <Box display="flex" gap={0.5} flexWrap="wrap">
                        {images.length > 0 ? (
                            images.slice(0, 1).map((file, index) => (
                                <Box key={index}>
                                    <img
                                        src={file?.filePath}
                                        alt="img"
                                        width={80}
                                        height={80}
                                        style={{
                                            objectFit: "cover",
                                            borderRadius: 4,
                                            border: "1px solid #ddd"
                                        }}

                                    />
                                </Box>
                            ))
                        ) : (
                            <Typography variant="caption">N/A</Typography>
                        )}
                    </Box>
                );
            }
        },
        {
            name: "Verified By",
            field: "verifiedBy",
            
        },
        {
            name: 'Status Of Compliance',
            field: 'statusOfCompliance',
            renderer: (row) => (
                <StatusBadge status={row?.statusOfCompliance} />
            )
        },
        {
            name: "Ageing ",
            field: "ageing",
        }

    ];




    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >

            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    {header}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Grid container>
                    <Grid size={{ md: 12 }}>
                        <TableComponent
                            columns={col}
                            data={ehsFindingData?.data || []}
                            createSortHandler={handleRequestSort}
                            loading={isFetching}
                            order={sortOrder}
                            orderBy={sortBy}
                        />
                    </Grid>
                    <Grid size={{ md: 12 }}>
                        <CustomPagination
                            totalCount={ehsFindingData?.totalRecords || 0}
                            pageSize={pageSize}
                            page={pageNumber}
                            onPageChange={handlePageChange}
                            setCurrentPage={setPageNumber}
                            onPageSizeChange={handlePageSizeChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default EhsFindingList;
